module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Mastering the Art of Southern Cooking")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("Foreword, by Pat Conroy ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03"
    }
  }, [_vm._v("The Very Beginning ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03#d0e176"
    }
  }, [_vm._v("Why Did We Write This Book? ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03#d0e202"
    }
  }, [_vm._v("What Makes Southern Food Unique? ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03#d0e604"
    }
  }, [_vm._v("How to Use this Book ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04"
    }
  }, [_vm._v("Starters ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e663"
    }
  }, [_vm._v("Peaches and Figs Wrapped in Country Ham ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e692"
    }
  }, [_vm._v("Country Ham with Baked Stuffed Figs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e723"
    }
  }, [_vm._v("Fig and Pecan Tapenade with Goat Cheese ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e766"
    }
  }, [_vm._v("Savory Fig Bites ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e816"
    }
  }, [_vm._v("Fried Watermelon Rind ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#stuffedtomatoes"
    }
  }, [_vm._v("Stuffed Grape Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e908"
    }
  }, [_vm._v("Indispensable Mushrooms with Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e955"
    }
  }, [_vm._v("Julia’s Kale Chips ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e985"
    }
  }, [_vm._v("Sautéed Zucchini or Squash Blossoms ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1010"
    }
  }, [_vm._v("Stuffed Zucchini or Squash Blossoms ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1049"
    }
  }, [_vm._v("Zucchini Rounds with Carrots ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1083"
    }
  }, [_vm._v("Lady Pea Patties ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1136"
    }
  }, [_vm._v("Coca-Cola-Glazed Wings ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1176"
    }
  }, [_vm._v("Grilled Chicken Saté ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1216"
    }
  }, [_vm._v("Pork and Peanut Hors d’oeuvres ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1262"
    }
  }, [_vm._v("Spicy Sausage Balls ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1293"
    }
  }, [_vm._v("Baby Crab Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1340"
    }
  }, [_vm._v("Herbed Shrimp and Scallop Ceviche ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1409"
    }
  }, [_vm._v("Shrimp and Cheese Grits Custards with Green Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1486"
    }
  }, [_vm._v("Bacon and Basil “Angels on Horseback” ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1528"
    }
  }, [_vm._v("Oyster Fritters ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1571"
    }
  }, [_vm._v("Grilled Skewered Oysters ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1608"
    }
  }, [_vm._v("Fried Frog Legs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1650"
    }
  }, [_vm._v("Shrimp and Okra Beignets with Salsa and Cilantro-Lime\n                  Sour Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1723"
    }
  }, [_vm._v("Pickled Shrimp, or “Swimpee” ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1757"
    }
  }, [_vm._v("Fried Clams ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1784"
    }
  }, [_vm._v("Pimento Cheese and Tomato Tart ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1835"
    }
  }, [_vm._v("Golden Vidalia Onion Tart with Olives and Rosemary ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1891"
    }
  }, [_vm._v("Bacon and Onion Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1935"
    }
  }, [_vm._v("Roasted Tomato Tart ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e1984"
    }
  }, [_vm._v("Nikki’s Roasted Tomato and Zucchini Lattice Tart ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2033"
    }
  }, [_vm._v("Crab Tart ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2098"
    }
  }, [_vm._v("Shrimp and Okra Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2141"
    }
  }, [_vm._v("Pepper Jelly Turnovers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2173"
    }
  }, [_vm._v("Cheese Sausage Pinwheels ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2209"
    }
  }, [_vm._v("Hot Country Ham-and-Cheese Rolls with Dijon–Poppy Seed\n                  Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#brittlebread"
    }
  }, [_vm._v("Sour Cream Brittlebread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#straws"
    }
  }, [_vm._v("Cheese Straws ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#minimuffins"
    }
  }, [_vm._v("Cornbread Mini-Muffins ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#gritscakes"
    }
  }, [_vm._v("Grits Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2416"
    }
  }, [_vm._v("Okra Griddle Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#caviar"
    }
  }, [_vm._v("Mississippi Caviar ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2505"
    }
  }, [_vm._v("Southern Hummus ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2568"
    }
  }, [_vm._v("Throw-Together Corn and Field Pea Dip ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2609"
    }
  }, [_vm._v("Food Processor Black-Eyed Pea Dip ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#chunky"
    }
  }, [_vm._v("Chunky Eggplant Spread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2696"
    }
  }, [_vm._v("Pork and Thyme Spread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2730"
    }
  }, [_vm._v("Chicken Liver Pâté ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2767"
    }
  }, [_vm._v("Guacamole ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2818"
    }
  }, [_vm._v("Fresh Trout Dip ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2865"
    }
  }, [_vm._v("Marion’s Crab Spread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2905"
    }
  }, [_vm._v("Cold Shrimp Paste Spread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e2944"
    }
  }, [_vm._v("Hot or Cold Shrimp Paste ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#pimento"
    }
  }, [_vm._v("Pimento Cheese ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e3023"
    }
  }, [_vm._v("Marinated Olives ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#butteredpecans"
    }
  }, [_vm._v("Buttered Pecans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e3088"
    }
  }, [_vm._v("Louis Limestone’s Roasted Peanuts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04#d0e3107"
    }
  }, [_vm._v("Julius’s Peanuts with Hot Peppers ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salads ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ambrosia ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Citrus, Fennel, and Pepper Salad Topped with Goat Cheese\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Log Cabin Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramelized Peach Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#roastedpineapple",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramelized Pineapple Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3497",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple and Cheese Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3539",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Fruit Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3586",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nathalie’s Watermelon Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3641",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waldorf Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3722",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gathered Greens Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3798",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Arugula Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3858",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salad of Baby Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3892",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collard or Turnip Greens Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3942",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iceberg Wedges with Buttermilk Blue Cheese Dressing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3965",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Asparagus Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3999",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Beet Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli and Roasted Red Pepper Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crunchy No-Cook Broccoli Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilted Cole Slaw for a Crowd ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Cole Slaw ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot Slaw with Poppy Seed Vinaigrette ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot and Fennel Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celery and Olives Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4418",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn and Butter Bean Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4457",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cucumber Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4486",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilted Cucumbers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4514",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cooked Cucumber Crescent Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4555",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Minted Cucumbers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4581",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggplant and Peanut Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4631",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Bean Salad with Vibrant Vinaigrette ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4663",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Bean, Blue Cheese, and Pecan Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#fennelsalad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fennel and Apple Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4735",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fennel Salad with Arugula ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4789",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Okra Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4829",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Onion Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4851",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vidalia Onion Bread Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e4890",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colorful Vidalia Onion and Bell Pepper Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fingerling Potato Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato and Basil Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato and Watermelon Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato and Cucumber Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato and Mango Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Aspic ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato, Avocado, Olive, and Green Onion Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#gazpacho",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gazpacho Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refreshing Zucchini Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice and Fruit Salad with Ginger Dressing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#eggsalad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Egg Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#chickensalad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Chicken Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5576",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Salad with Grapes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5620",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crab, Mango, and Avocado Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5667",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Oyster Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5701",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated Shrimp Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5750",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5800",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet and Savory Grilled Shrimp Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5836",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp and Pea Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5880",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Shrimp, Pepper, and Rice Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5912",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5974",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roast Beef Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e6014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mayonnaise & Vinaigrette Dressings ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#mayonnaise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mayonnaise ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#redmayonnaise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic and Red Pepper Mayonnaise ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#basicvinaigrette",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Vinaigrette ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#honeyvinaigrette",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Vinaigrette ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#southerndressing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Southern Dressing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#vidaliahoney",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vidalia Honey Mustard Dressing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#buttermilkdressing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttermilk Blue Cheese Dressing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#gingerdressing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ginger Dressing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#seedvinaigrette",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poppy Seed Vinaigrette ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#vibrantvinaigrette",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vibrant Vinaigrette ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stocks, Soups, Gumbos, & Stews ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#stocks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stocks ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6616",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Chicken or Turkey Stock ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#amber",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amber Turkey Stock ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6709",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Court Bouillon or Vegetable Stock ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#shrimpstock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Stock ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#corncob",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corncob Stock ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#fishbroth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Country-Style Fish Broth ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6851",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soups, Gumbos, & Stews ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6855",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Avocado Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6885",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6913",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Raspberry-Blueberry Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6954",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pale Pink Iced Cucumber and Mint Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6998",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chilled Melon Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bourbon-Spiked Cold Peach Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttermilk-Tomato Cold Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gazpacho ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Golden Gazpacho with Chilies and Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bubbly Butter Bean Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gold and Crimson Beet Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange and Carrot Curried Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream of Carrot and Zucchini Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7452",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comforting Cheese Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn Bisque ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7553",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushroom Soup with Grits or Rice ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#crabsoup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("She-Crab Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#onionsoup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vidalia Onion Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7704",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oxtail Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7751",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Creamy Peanut Ginger Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7790",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dried Peas Porridge with Coriander and Mint ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Acre and Greens Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7910",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pimento Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e7958",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Squash Pecan Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bourbon Sweet Potato and Greens Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Bisque ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turnip and Greens Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turtle Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mix ’n’ Match Vegetable Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon, Tomato and Field Pea Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butter Bean and Sausage Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garden Vegetable and Sausage Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hurricane Soup with Breadcrumb Dumplings ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8455",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turnip Green, Black-Eyed Pea, and Rice Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#bouillabaisse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lowcountry’s Best Fish Muddle (Southern\n                  Bouillabaisse) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8664",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Football Chili ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8733",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs. Lyndon B. (Lady Bird) Johnson’s Pedernales River\n                  Chili ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8777",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetarian Chili ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8875",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Derian/Carter Roux-Less Gumbo ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e8952",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roast Chicken Gumbo ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e9016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish Camp Duck Gumbo ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e9081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charleston Seafood Gumbo ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e9150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crab and Tomato Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e9190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oyster Stew ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetables & Sides ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#globe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Globe Artichokes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Globe Artichokes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Artichokes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9463",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jerusalem “Sunchoke” Artichokes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9480",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Jerusalem Artichokes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9514",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asparagus ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9554",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Asparagus ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9609",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled or Broiled Asparagus ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9657",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asparagus and Red Bell Pepper Stir-Fry ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9692",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beans and Peas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9782",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butter Beans or Butter Peas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9825",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Succotash ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#greenbeans",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Beans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9972",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pan-Charred Green Beans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e9992",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Green Beans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home-Style Green Bean Casserole ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Pole Beans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crisp Pole Beans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black-Eyed Peas with Hog Jowl ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#hoppin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hoppin’ John ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Crowder Peas with Snaps ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English (Green) Peas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed English Peas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cajun Roux Peas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttery English Peas and Tomato ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamed English Peas and Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#beets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beets ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#roastedbeets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Beets ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10466",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10482",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Braised Broccoli ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10512",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli Trees Slathered with Garlic ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10538",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli Stir-Fry Medley ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10566",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli with Red Pepper, Olives, and Feta ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10602",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chopped Broccoli and Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10634",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brussels Sprouts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10645",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Brussels Sprouts Leaves ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10668",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Brussels Sprouts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10694",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Poached Brussels Sprouts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10756",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cabbage ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10767",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Cabbage ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10807",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Steamed Cabbage ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10848",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamed Sautéed Cabbage ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10877",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sophisticated Red Cabbage ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10913",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrots ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10923",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glazed Baby Carrots ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e10965",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Grated Carrots ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Carrots ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ribboned Carrots and Zucchini ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrots and Celery with Ginger ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cauliflower ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cauliflower with Herbed Vinaigrette ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cauliflower and Cheese Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celery ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celery and Red Pepper Bundles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sliced Celery with Pecans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#corn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Corn and Squash Pudding ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#creamcorn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamed or Fried Corn ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11457",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New-Style Fried Corn ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#maque",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maque Choux ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11524",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggplant ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#ratatouille",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggplant and Red Pepper Stew (Southern Ratatouille)\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11611",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No-Fail Eggplant Lasagna ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#fennel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fennel ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11711",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crisp-Tender Fennel and Zucchini ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11739",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fennel Gratin with Parmesan Cheese ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11774",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#greens",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#likker",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Mess of Greens and “Pot Likker” ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11907",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poke Sallet with Green Onions and Bacon ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#sauteedgreens",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Sautéed Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e11986",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chiffonade of Turnip, Collard, Kale, or Baby Beet\n                  Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e12024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushrooms ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushroom Duxelles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Mushrooms ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Portobello Mushrooms ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Okra ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stir-Fried Okra ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#friedokra",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pan-Fried Okra ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#okrachips",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Okra Chips ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margaret Lupo’s Deep-Fried Okra ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Okra and Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12422",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated Okra ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12461",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onions, Leeks, and Shallots ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12607",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Onions ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#caramelized",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramelized Onions ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12733",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Green Onion, Scallion, or Leek Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12804",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braised Leeks ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12835",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stone-Ground-Grits-Fried Onion Rings ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12872",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bell Peppers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#roastedpeppers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charred Red Peppers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e12924",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whipped, Mashed, or Riced Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Potatoes, Onions, and Turnips ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ribboned Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Fingerling Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic-Flavored Giant Potato Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#anna",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anna’s Potato Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Crisp Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snacking Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lazy Potato Jewels ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Baked Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13431",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robbinsville Fried Ramps and Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13480",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Squash ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13491",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zucchini and Celery Sauté ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13524",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Yellow and Green Squash Sauté ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13567",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grated Zucchini ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13600",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Baked Squash Rounds ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13629",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broiled or Grilled Zucchini and Red Pepper ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13667",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Layered Zucchini and Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13706",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Squash and Zucchini Boats ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13742",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Squash Casserole ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13785",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winter Squash ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13791",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sorghum or Sweet Molasses Acorn Squash ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13816",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13822",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Sweet Potatoes with Pecans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13840",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skillet-Cooked Brown Sugar Sweet Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13866",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Sweet Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13895",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twice-Baked Stuffed Sweet Potatoes with Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13935",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato and Turnip Gratin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e13986",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roberta’s Tomatoes and Cucumbers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#roastedtomatoes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Roasted Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basil and Cheese-Stuffed Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Green Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Tomato Cornbread Crumble ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turnips ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grated and Sautéed Turnips ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingered Vegetable Medley ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turnips and Cream au Gratin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turnips and Red Peppers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14438",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almost-Steamed Vegetables ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14464",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charcoal-Broiled Vegetables ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14504",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Layered Oven-Roasted Vegetables ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14535",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14644",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grits with Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14687",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato-Bacon Grits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14726",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14797",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Rice and Mushrooms ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14829",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creole Dirty Rice ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14872",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs. Dull’s Steamed Rice ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14895",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushroom Pilau ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14933",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Pilau (aka Red Rice) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e14992",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Okra Pilau ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e15022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffings and Dressings ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e15034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southern Cornbread Dressing (Cush) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e15110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuart Woods’ Pecan Biscuit Dressing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e15148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple, Sausage, and Fennel Biscuit Dressing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e15194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Rice Dressing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e15242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Circle Macaroni Pie (Custard Macaroni and\n                  Cheese) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e15286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Macaroni Pie (Macaroni and Cheese) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07b#d0e15317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Macaroni and Cheese ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggs ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e15578",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decadent Toad in a Hole ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e15606",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggs Benedict ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e15643",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soft Scrambled Eggs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#peachomelet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramelized Peach or Mango Omelet ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e15728",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deviled Eggs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e15763",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheese Custards ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e15802",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Corn Custards ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#souffles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soufflés ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e15941",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheese Soufflé ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e16028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Spoon Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e16068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greens and Ham Spoon Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#gritssouffle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheese Grits Soufflé ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#omelets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Omelet Soufflé ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e16177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Cheese Soufflé Casserole ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish & Seafood ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16434",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Broiled, Griddled, or Grilled Fish Fillets with\n                  Lemon or Lime ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16495",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Fish Fillets Marinated in Barbecue Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16529",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Tuna Steak ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16565",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Fish Steaks ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16609",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Stuffed Sea Trout ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16667",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spice-Rubbed Roasted Fish Fillets ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16703",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daufuskie Roasted Fish Fillets ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16754",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Fish Fillets with Creole Sauce and Pecans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16818",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Roasted Snapper ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16874",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Roasted Fish with Spinach ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e16912",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Roasted Flat Fish Stuffed with Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#moistfish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moist Fish in a Pouch ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Roasted Fish Filled with Peppers and Olives ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Roasted Pecan-Crusted Fish Fillets ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onion-Topped Roasted Fish Fillets ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salt-Crusted Whole Roasted Fish ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steamed Southern-Chinese Fillets ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Catfish ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Flounder Strips with Raisins and Pecans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17438",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Sautéed Trout in Butter Pecan Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17479",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Poached Fish Fillets with Light Pecan Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17513",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blue Trout ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17560",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Broiled Shad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17601",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Shad Roe ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17665",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Shad with its Roe and Corn Butter Sauce")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17729",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crab ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17766",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steamed Hard-Shell Crabs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17789",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intern Crab Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17855",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled or Broiled Soft-Shell Crabs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17877",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Soft-Shell Crab ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17908",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shallow-Fried Lemon Soft-Shell Crab ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17937",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crawfish ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17943",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crawfish or Shrimp Boils ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e17979",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clams ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steamed Soft-Shell Clams ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled or Oven-Steamed Hard-Shell Clams ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All-in-one Clams with Greens and Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#lemonbatter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Batter for Seafood ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Orleans–Style Barbecue Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acadian Peppered Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Creole ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Cooked New Orleans Spicy Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18456",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp and Cucumbers with Peanut Butter Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18495",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp and Okra in a Tangy Butter Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18529",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Pilau ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18569",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Curried Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18622",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grace’s Fried Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18654",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nana Stuffie’s Fried Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18689",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Original Breakfast Shrimp and Grits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18734",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Burgers or Sliders ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18793",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oysters ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18833",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cicero’s Oyster Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18867",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broiled Oysters with American Caviar ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e18896",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Oysters ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poultry ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e18987",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Favorite Buttermilk Skillet-Fried Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Country Captain ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken, Orange, and Tomato Casserole ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hunter’s Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Maque Choux ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Chicken with Mushrooms and Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken with Turnips and Sweet Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19494",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbecued Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19592",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Sautéed Bone-in Chicken Breasts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19709",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moist and Fast Chicken Breasts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19770",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Breasts with Bacon and Zucchini ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19823",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Scaloppine ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19879",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple and Cheese–Stuffed Chicken Breasts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19941",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sesame and Turmeric Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e19993",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Fried Chicken Breasts with Pecan Crust ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stir-Fried Greens, Chicken Breasts, and Peanuts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Grilled, Griddled, or Broiled Chicken Breasts\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken with Tomato Salsa ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skillet Lemon Chicken Drumsticks or Thighs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruity Chicken Drumsticks or Thighs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tucker Thighs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poached Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Crispy Grilled or Roasted Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#roastedchicken",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted (Baked) Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20552",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finger-Licking Jerk Skillet Chicken Wings and Sweet\n                  Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20592",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon-Rosemary Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20651",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken and Rice Pilau ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20698",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Bog ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20724",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken and Pepper Dumplings ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20776",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Pot Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20840",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pan-Fried Chicken Livers with Caramelized Onions and\n                  Country Ham ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#turkey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkey with Gravy ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20928",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Turkey Gravy ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20959",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sinful Dumpling Gravy ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e20987",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Cornish Hens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e21050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Quail ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e21118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Duckling with Mint and Lemon ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e21215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dixie Cassoulet ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meats ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Pork Tenderloin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Sautéed Pork Tenderloin Biscuit Slices ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21444",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry-Stuffed Pork Tenderloin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21551",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Pepper-and-Peanut-Roasted Pork Tenderloin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21597",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Barbecued Pork Tenderloin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21640",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Medallions, Cutlets, or Scaloppine ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21721",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Loin Basted with Hot Pepper Jelly Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21781",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zippy Pork Loin Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21826",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Loin Roast with Dried Fruit ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21925",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange-Ginger Pork Chops ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e21963",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cider-Brined Pork Chops with Caramelized Apples and\n                  Onions ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled or Broiled Mustard Pork Chops ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated Smoked Pork Chops on Mississippi Caviar ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memphis Barbecued Ribs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coca-Cola Ribs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#crownroast",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crown Roast of Pork ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sausage and Apples ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#carmapple",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramelized Apples and Onions ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#slowpork",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow-Cooked Pork Shoulder (aka Boston butt aka Picnic\n                  Ham) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braised Pork Shoulder (Picnic Ham) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22471",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Pork Leg (Ham) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#lechonnat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lechon de Natividad (Suckling Pig, Whole Pig, or Ham)\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22708",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chitlins ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22835",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Country Ham ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22888",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Redeye Ham with Coca-Cola Redeye Gravy ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e22920",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glazed Ham Steak ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#bakedbacon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven Baked Bacon ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#cracklin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cracklins ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tenderloin Stuffed with Country Ham and Parmesan Cheese\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Beef Tenderloin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fillet Stuffed with Basil and Greens ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boneless Rib-Eye ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23447",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bourbon-Flamed Rib Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23503",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peppered Tri-Tip Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23542",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oxtail Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23598",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Stew with Fennel, Pecans, and Orange ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23663",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon-Lime Pot Roast with Tomatoes and Garlic ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23713",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braised Beef with Caramelized Onions and Garlic ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23759",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandmother Rhoda’s Pot Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23821",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basil-Lemon Pot Roast with Vegetables ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23875",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated and Smoked Brisket ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23931",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cynthia’s Brisket ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e23965",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bourbon Rosemary Beef Round Tip Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e24008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carpetbag Steaks ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e24084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herb-Crusted Pan-Seared Tenderloin Steaks ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sirloin Steaks with Fresh Spinach ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greens and Chorizo-Stuffed Flank Steak ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flank Steak with Mushroom Dijon Gravy ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated Flank Steak ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sour Cream Swiss Steak ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken-Fried Steak with Flannel Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24433",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother’s Meatloaf ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kathy’s Meatloaf ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24579",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beth’s Meatloaf ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24649",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Cooked Meatballs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24689",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homey Short Ribs with Potato Dumplings ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24730",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lime and Beer Short Ribs with Mustard Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24779",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated Shish Kebabs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24817",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calf’s Liver with Onions and Brown Butter ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24865",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24908",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Butterflied Leg of Lamb ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24967",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broiled or Grilled Lamb with Herbs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e24997",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb Chops with Mint-Mustard Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e25047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rack of Lamb with Muscadine Sauce or Red Currant Jelly\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11b#d0e25105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lollipop Lamb ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breads ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Breads ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheddar Muffin Bites ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yorkshire Pudding Popovers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-Pot Banana Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Processor Zucchini Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Tea Loaf with Ginger ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25444",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kelly’s Banana Chocolate Chip Muffins ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25486",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Coffee Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25538",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Pancakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25575",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crêpes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25636",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttermilk Waffles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25702",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Golden Brown Southern Grits Waffles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#batter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light Batter ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#lacyfritters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lacy Corn Fritters (Hoecakes) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25815",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs. Peters’ Cornmeal Batter Griddle Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25854",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Griddlecakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25891",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hush Puppies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e25950",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biscuits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two-Ingredient Biscuits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#basicbis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Southern Biscuits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#refrigeratorbis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Refrigerator Biscuit Mix ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kate’s Unforgettable Wooden Bowl Biscuits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#angel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angel or Bridegroom’s Biscuits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato or Pumpkin Biscuits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beaten Biscuits ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornbread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#cornbread",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light and Tender Cornbread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26445",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Cornbread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26495",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skillet Cornbread with Bacon Drippings ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26545",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttermilk Cornsticks or Cornbread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26598",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Cornbread Muffins ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26670",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dori’s Peach Cornmeal Muffins ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26716",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cynthia’s Snacking Sour Cream Cornbread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26745",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yeast Breads ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#noknead",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic No-Knead Artisan Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#crustybread",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Processor Quick-Rise Crusty Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e26989",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baker’s Bread (???TITLE???) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#processor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beginner’s Loaf Food Processor Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e27099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Loaf Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#sally",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sally Lunn Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e27200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandmother Kreiser’s Powder-Puff Dinner Rolls ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e27268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruit, Seed, and Nut Bread ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e27314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan and Currant or Apple Ring ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e27394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brioche Rolls ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e27439",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rich Cloverleaf Rolls ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e27497",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Beignets ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e27539",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Croûtes ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastries & Pies ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#piecrust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Very Beginner’s Piecrust (???TITLE???) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#basicpiecrust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Piecrust ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#doublepiecrust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Crust Piecrust ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#processorpie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Processor Piecrust ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#mixerpie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mixer Piecrust ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#sweetpie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Piecrust (???TITLE???) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#creamcheese",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Very Versatile Cream Cheese Dough ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e28224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream Cheese Dough with Vinegar ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#cookiecrust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookie Crusts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#pecancrust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Crust ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#phyllo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phyllo Cups ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e28373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rapid Puff Pastry ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#puffs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nathalie’s Cream Puffs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#tassies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Tassies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e28656",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruit Tarts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e28708",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elegant Chocolate Pecan Tarts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e28755",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon and Berry Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#lemonmeringue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Meringue Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e28851",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornmeal Lemon Chess Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e28891",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chess Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e28927",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Peanut Butter Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e28985",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Susan’s Coconut Custard Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home-Style Buttermilk Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#pecanpie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Cream Pecan Crust Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin-Chocolate Cheesecake Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LuLen’s Grated Apple Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Pumpkin Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Melt-in-Your-Mouth Sweet Potato Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Pecan Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Pecan Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Crust Blueberry Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29451",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free-Form Blueberry Cornmeal Croustades ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29499",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach-Pecan Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29549",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peaches ’n’ Cream Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29589",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free-Form Tarts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29648",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free-Form Apple Tart ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29691",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29734",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sundance Rivera’s Peach Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29774",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Brown Sugar Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29813",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Cinnamon-Apple Double-Crust Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29865",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raspberry-Mint Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29909",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Key Lime Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e29950",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon-Lime Meringue Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e30013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nana’s Banana Cream Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e30064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miss Mary’s Date and Soda Cracker Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e30098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried Fruit Pies ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cakes ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#cobblers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cobblers, Dump Cakes, or Batter Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick ’n’ Easy Cinnamon Apple Cobbler ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#lazycobbler",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lazy Girl Peach Batter Cobbler ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30483",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs. Dull’s Simple Apple Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30523",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home-Style Peach Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30563",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Apple Cake with Caramel Topping ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30613",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hummingbird Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30673",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30729",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Buttermilk Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30788",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coca-Cola Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30868",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach or Pineapple Upside-Down Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30922",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old-Fashioned Gingerbread with Peach Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#buttercakes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butter Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e30997",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Poppy Seed Pound Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old-Fashioned Pound Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream Cheese–Brown Sugar Pound Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Chocolate Pound Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plain 1-2-3-4 Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Updated 1-2-3-4 Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#foamcakes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foam Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs. Lane’s Prize Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#coconutcake",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31561",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Caramel Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31626",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Snack Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31694",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southern Belle Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31761",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange or Lemon Daffodil Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31816",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mississippi Mud Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31857",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Fruitcake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31912",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Molten Chocolate Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31942",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stack Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e31976",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesecake with Chocolate Crust ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#icings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glazes and Icings ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e32020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brown Sugar Glaze ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#lemonglaze",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Lemon or Orange Glaze ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#caramelicing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#quickcaramelicing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Caramel Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#burnticing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burnt Sugar Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#meringueicing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meringue Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#caneicing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sorghum or Cane Syrup Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#chocolateicing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rich Chocolate Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#lazyicing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lazy Orange Buttercream Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#bourbonicing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bourbon Hard Sauce Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e32315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Browned Butter Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#creamicing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream Cheese Icing ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e32392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southern Whiskey Sauce ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memorable Sweets ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32447",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32506",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Cookies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32549",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Crescents ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32583",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shortbread Cookies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32631",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lacy Pecan Cookies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32691",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Benne Seed Wafers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32757",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beginner’s Lemon Bars ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32791",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Processor Florentine Lace Cookies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32840",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moravian Ginger Snaps ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32890",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chip or Kiss Cookies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32944",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charleston Chewies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e32980",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meringues ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#meringue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Simple Meringues ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swiss Meringues ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italian Meringues ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pavlova ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#nutmeringue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nut Meringue ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Floating Islands ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cloud Roll ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Roll ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Roll with Chocolate Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#lemonsouffle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Lemon Soufflé or Mousse ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33509",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Lemon Soufflé-Pudding ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33570",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Chocolate Soufflé ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33628",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Desserts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33652",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Perfect Brownie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33680",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Chocolate Mousse ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33734",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Snowballs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33792",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Shards ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33809",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother’s Chocolate Cream Fudge ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#pecantorte",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Pecan Torte ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33890",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruit Desserts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33894",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Tropical Fruit ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33926",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon Basket with Fresh Berries ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33967",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Fool ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e33989",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry-Peach Crisp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Strawberries ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Pudding ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Charlotte ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#custards",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Custard Desserts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#lemoncurd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Curd (Lemon Cheese) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#anglaise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crème Anglaise ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#peachcustard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach or Mango and Cream Custard with Caramel Pecan\n                  Topping ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Ginger Flan ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grits Pudding ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach and Grits Parfait ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#ricepudding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Rice Pudding ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34512",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice Custard Pudding ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34563",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Rice Pudding ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34610",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar Work ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34614",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar Syrup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#caramel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34727",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oranges in Caramel Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34749",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Oranges ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#citrus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Citrus Rind ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34817",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Lemon Slices ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34836",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divinity ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34866",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charleston Pralines ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34924",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Super-Thin Pecan Brittle ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34964",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ice Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e34968",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plain Vanilla Ice Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e35017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Caramel Mousse Ice Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e35065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Curd Ice Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e35090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterscotch Ice Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e35133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Mint Ice ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#butterscotch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterscotch Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#chocolatesauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#sabayonsauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange-Lemon Sauce (Citrus Sabayon Sauce) ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e35245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot-and-Pineapple Filling ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e35277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raspberry Cream ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Condiments, Savory Sauces, & Marinades ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preserved Condiments ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refrigerator Cucumber Pickles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margaret Ann’s Dried Curried Fruit ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#cranberry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cranberry Relish ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35479",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meyer Lemon Relish ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#onionrelish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Onion Relish ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35558",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn Relish ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35600",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refrigerator Green Tomato Relish ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#conserve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Conserve or Preserve ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35663",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruit Butters & Spreads ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#peachbutter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Butter ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#figjam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig Jam or Butter ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35726",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Figs and Fennel ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35756",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Refrigerator Strawberry Jam ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35785",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onion Jam ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#pepperjelly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Pepper Jelly ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35856",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange-Lemon Marmalade ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e35911",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sauces ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#hollandaise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hollandaise Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#whitesauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#buttersauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Butter Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#milk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flavored Milk ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#creolebrown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creole Brown Fish Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e36427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pepper Jelly Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e36460",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Bell Pepper Dip or Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#cocktail",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cocktail Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#tartar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tartar Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e36553",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creole Rémoulade Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#norman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norman’s Rémoulade ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e36622",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fennel Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#peanutsauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Sauce or Dip ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#gingerpeanutsauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ginger Peanut Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#tomatosauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#marinara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinara Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e36768",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southern Basil Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e36796",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Mustard Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#sweetbar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Barbecue Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e36850",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tart Barbecue Basting Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#georgiasauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Georgia Peach Barbecue Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#barbecuesauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vinegar-Based Barbecue Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#vinegarsauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vidalia Onion and Vinegar Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e36997",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig and Bourbon Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#muscadine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muscadine Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Browned Butter Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#pansauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical Pan Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#mustardsteak",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mustard Sauce for Steaks and Chops ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#salsa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salsa ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach and Cucumber Salsa ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lime Cucumber Salsa ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flavored Butter ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#creole",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creole Seasoning ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#jamaican",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jamaican Jerk Seasoning ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#oliveoil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perfumed Olive Oil ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#ginger",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preserved Ginger ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinades ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic-Thyme-Wine Marinade ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic-Wine Marinade ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Lime Marinade ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soy Sauce Marinade ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37461",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rubs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#allrub",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All-Purpose Rub ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37482",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Rub ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e37501",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoky Rub ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibiography")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c9184c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 63
// module chunks = 0